SWR.Social.prototype._getSoundcloudParams = function _getSoundcloudParams(){
  var self = this;
  var data = {};

  // Soundcloud
  data.endpoint = 'https://soundcloud.com/oembed';
  data.params = {
    'show_comments': true,
    'iframe': true,
    'color': 'ff5500',
    'auto_play': false,
    'maxwidth': '550',
    // nicht offiziell
    'hide_related': true,
    'show_user': true,
    'show_reposts': false,
    'omitscript': false
  };
  data.dataType = 'json';

  return data;
};
